<div class="content">
  <h1>Stängt!</h1>
  <p>Vi har stängt för underhåll, välkommen tillbaka om en stund.</p>
  <p>Vi beräknar att öppna igen {{ opens }}</p>
</div>
